<section class="mx-auto w-full max-w-[90rem] p-5 md:px-8">
  <div class="pb-4">
    <a
      routerLink="/orders"
      class="mb-1 inline-flex items-center gap-1 text-xs font-semibold tracking-widest text-blue-700 uppercase"
      aria-label="Back to Orders"
    >
      <span
        class="material-icons-outlined text-[12px] leading-none"
        aria-hidden="true"
        >arrow_back</span
      >
      Orders
    </a>
    <h1 class="m-0 text-3xl leading-tight font-bold">Order Insights</h1>
    <p class="mt-1 text-sm text-gray-400">
      Live overview of order volumes, circuit milestones, and activation status.
    </p>
  </div>

  @if (loadingAllPage) {
    <div class="flex items-center justify-center py-20">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else {
    <div class="grid grid-cols-1 gap-4 lg:grid-cols-4">
      <!-- Col 1: Service Overview (spans 2 rows) -->
      <div class="lg:row-span-2">
        <app-service-overview
          title="Service Overview"
          [list]="serviceOverviewList"
          [loading]="loading"
          extraClass="overview"
          (navigate)="navigate($event)"
        ></app-service-overview>
      </div>

      <!-- Row 1 cols 2-4: Bullet status cards -->
      <app-bullet-status
        bulletClass="preparing-order-vendor"
        title="Preparing Order for Vendor"
        [value]="countPreparing"
        [loading]="loading"
      ></app-bullet-status>

      <app-bullet-status
        bulletClass="count-implementation"
        title="Implementation"
        [value]="countImplementation"
        [loading]="loading"
      ></app-bullet-status>

      <app-bullet-status
        bulletClass="count-installed"
        title="Installed"
        [value]="countInService"
        [loading]="loading"
      ></app-bullet-status>

      <!-- Row 2 cols 2-4: Circuit Milestones -->
      <div class="lg:col-span-3">
        <app-circuit-milestones
          [data]="milestonesData"
          [loading]="milestonesDataLoading"
          (navigate)="navigate($event)"
        ></app-circuit-milestones>
      </div>

      <!-- Row 3: Activation Status | In-progress | Pending FOC -->
      <app-service-overview
        title="Activation Status"
        [list]="startOfServiceList"
        [loading]="loading"
        extraClass="bottom"
        (navigate)="navigate($event)"
      ></app-service-overview>

      <app-service-overview
        title="In-progress Services"
        emptyMessage="There are currently no in-flight orders"
        [list]="inFlightServiceList"
        [loading]="inFlightServiceLoading"
        extraClass="bottom scroll"
        (navigate)="navigate($event)"
      ></app-service-overview>

      <div class="lg:col-span-2">
        <app-pending-foc-dates
          [data]="pendingFocDateList"
          [total]="pendingFocDateTotal"
          [loading]="pendingFocDateLoading"
          (navigate)="navigate($event)"
        ></app-pending-foc-dates>
      </div>
    </div>
  }
</section>
